module.exports = __webpack_public_path__ + "static/UnclickTripWasCut-acbe6222d69824731968653a6a1eb494.png";